<script setup>
import { ref, watch } from 'vue';
import anime from 'animejs';

const props = defineProps({
    number: {
        type: Number,
        required: true,
    },
});
const displayValue = ref(props.number);

// Watch for changes in the value prop
watch(
    () => props.number,
    (newValue, oldValue) => {
        // Skip animation if it's the initial value
        if (newValue === oldValue) return;

        const obj = { value: oldValue };

        // Animate using anime.js
        anime({
            targets: obj,
            value: newValue,
            //round: Math.pow(10, 0), // Round to the specified decimal places
            round: 1,
            duration: 1000,
            easing: 'easeOutQuart',
            update: () => {
                displayValue.value = obj.value;
            },
        });
    },
);

defineOptions({
    name: 'AnimatedNumber',
});
</script>

<template>
    <span>{{ displayValue }}</span>
</template>
